import { Routes } from '../../nav/routes'

interface DisabledInterface {
  route: string
  isErrorActive: boolean
  isloading: boolean
  amount: string | number
  totalAmount?: string | number
  isInvalidStatus?: string
  showInvoiceId?: boolean
  invoiceError?: string
  invoiceId?: string
}

interface blurInterface {
  route: string
  getRefundValid: (
    status: string,
    totalAmount: number | string,
    amount: number,
    setError: () => void,
    isInvalidStatus: boolean,
  ) => void
  status: string
  totalAmount?: string | number
  amount: string | number
  setError: (string: string) => void
  isInvalidStatus: boolean
}

interface onPressInterface {
  route: string
  handleRefund: () => void
  generateQR: () => void
}

interface onChangeInterface {
  route: string
  getErrorOfRefund: (amt: number | string) => void
  checkErrorOfQr: (amt: number | string) => void
  amt: number | string
}

export const isButtonDisabled = ({
  route,
  isErrorActive,
  amount,
  totalAmount,
  isInvalidStatus,
  isloading,
  showInvoiceId,
  invoiceError,
  invoiceId,
}: DisabledInterface) => {
  let disabled = false
  switch (route) {
    case Routes.TRANSACTIONS:
      if (
        isErrorActive ||
        (showInvoiceId && invoiceError !== '') ||
        (showInvoiceId && invoiceId === '') ||
        Number(amount) === 0 ||
        Number(amount) > Number(totalAmount) ||
        isInvalidStatus ||
        isloading ||
        !String(amount).match(/^-?\d*\.?\d*$/)
      ) {
        disabled = true
      }
      break

    case Routes.QR_CODE:
      if (Number(amount) < 1) {
        disabled = true
      }
      break

    default:
      disabled = true
      break
  }
  return disabled
}

export const onBlur = ({
  route,
  getRefundValid,
  status,
  totalAmount,
  amount,
  setError,
  isInvalidStatus,
}: blurInterface) => {
  switch (route) {
    case Routes.TRANSACTIONS:
      getRefundValid(status, amount, setError, isInvalidStatus, totalAmount)
      break

    case Routes.QR_CODE:
      break

    default:
      break
  }
}

export const onPress = ({ route, handleRefund, generateQR }: onPressInterface) => {
  switch (route) {
    case Routes.TRANSACTIONS:
      handleRefund()
      break

    case Routes.INITIATEREFUNDS:
      handleRefund()
      break

    case Routes.QR_CODE:
      generateQR()
      break

    default:
      break
  }
}

export const onchangeText = ({ route, getErrorOfRefund, checkErrorOfQr, amt }: onChangeInterface) => {
  switch (route) {
    case Routes.TRANSACTIONS:
      getErrorOfRefund(amt)
      break

    case Routes.QR_CODE:
      checkErrorOfQr(amt)
      break

    default:
      break
  }
}
